// extracted by mini-css-extract-plugin
module.exports = {"container":"h6","image":"h7","title":"h8","date":"h9"};